module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "main-width set-position"
  }, [_c('div', {
    staticClass: "footer-left pull-left"
  }, [_c('div', [_c('p', [_vm._v("南方水泥有限公司 版权所有")]), _vm._v(" "), _c('p', [_vm._v("建议使用IE9.0以上浏览器 1366*768分辨率")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eb198a1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-footer.vue
// module id = 39
// module chunks = 4 5 6 7 8 9 10 11 12 13